/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Kopfbereich im Hauptdialog
 *
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as appActions from "../../store/actions/appActions";
import * as utils from "../../basics/utils";

class Welcome extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const styleText = utils.getStyleHeight(this.props.width, .04, .04, .04)

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderUpper = () => {

            const style = { backgroundColor: (this.debug) ? 'green' : '' }

            return (
                <div className={"w-full flex flex-col font-thin pt-2"} style={style}>
                    <div className="w-full whitespace-nowrap" style={styleText}>WILLKOMMEN IN DER</div>
                    <div className="w-full whitespace-nowrap" style={styleText}>WELT DER INTRALOGISTIK.</div>
                </div>
            )
        }

        const renderLower = () => {

            const style = { backgroundColor: (this.debug) ? 'blue' : '' }

            return (
                <div className={"w-full flex flex-col font-normal pt-2"} style={style}>
                    <div className="w-full whitespace-nowrap" style={styleText}>IMMER AKTUELL UND</div>
                    <div className="w-full whitespace-nowrap" style={styleText}>OFFLINE VERFÜGBAR.</div>
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        return (
            <div className="w-full flex flex-col text-white " >
                {renderUpper()}
                {renderLower()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
